<template>
	<div class="cms-spacer-block" :style="spacerStyle"></div>
</template>

<script>
/**
 * SpacerBlock.vue
 * ───────────────
 * An empty block that adds vertical whitespace between blocks.
 */
export default {
	name: 'SpacerBlock',

	props: {
		height: { type: String, default: '40px' }
	},

	computed: {
		spacerStyle: function () {
			return { height: this.height };
		}
	}
};
</script>

<style scoped>
.cms-spacer-block { width: 100%; }
</style>
